import type { ChangeEvent } from 'react';
import React from 'react';
import Input, { baseFieldClasses } from '../../../form/Input';

interface SearchFieldProps {
    onChange?: (value: string) => void;
    value?: string;
}

function SearchField({ onChange, value }: SearchFieldProps) {
    return (
        <Input
            className={baseFieldClasses}
            aria-label={gettext('SEARCH_NOTIFICATIONS')}
            placeholder={gettext('NOTIFICATION_SEARCH_PLACEHOLDER')}
            value={value}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value)}
        />
    );
}

export default SearchField;
